import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { SINGLE_DOCUMENT_TYPES, STATUS_UNLOADING, DRIVER_NO_ACTION_DOC_TYPES } from '../../shared/constants';
import { SHIPMENTS_ROUTE_MY_SHIPMENTS, SHIPMENTS_ROUTE_SHIPMENT_DOCUMENT_VIEW } from '../../shared/routes';

const ROUTE_DOCUMENTS = 'documents';
const POD_LABEL_TYPE = 'ProofOfDelivery';

@Component({
    selector: 'app-document-tile-box',
    templateUrl: './document-tile-box.component.html',
    styleUrls: ['./document-tile-box.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule,
      MatCardModule
    ]
})
export class DocumentTileBoxComponent implements OnInit {
  @Input() document;
  @Input() shipment: any;
  singleDocumentFiles = [...SINGLE_DOCUMENT_TYPES, ...DRIVER_NO_ACTION_DOC_TYPES];
  isDisabled = false;

  constructor(private readonly route: Router) {}

  ngOnInit(): void {
    if (this.shipment.status !== STATUS_UNLOADING && this.document.name === POD_LABEL_TYPE) {
      this.isDisabled = true;
    }
  }

  navigateToUpload(type: string): void {
    const id = this.document.document ? this.document?.document[0]?.id : '';

    if (this.singleDocumentFiles.includes(type) && id) {
      const path = `${SHIPMENTS_ROUTE_SHIPMENT_DOCUMENT_VIEW}/${this.shipment.id}/${id}`;
      this.route.navigate([path]);
    } else {
      let path = `/${SHIPMENTS_ROUTE_MY_SHIPMENTS}/${this.shipment.id}/${ROUTE_DOCUMENTS}/${type}`;
      this.route.navigate([path]);
    }
  }

  getCardStatusClass(document: any): string {
    if (this.isDisabled) {
      return 'status-disabled';
    }
    if (document?.isPresent) {
      return 'status-completed';
    }
    return 'status-pending';
  }

  getStatusIcon(document: any): string {
    if (this.isDisabled) {
      return 'block';
    }
    if (document?.isPresent) {
      return 'check_circle';
    }
    return 'radio_button_unchecked';
  }

  getStatusText(document: any): string {
    if (this.isDisabled) {
      return 'Disabled';
    }
    if (document?.isPresent) {
      return 'Uploaded';
    }
    return 'Not Uploaded';
  }

  getDocumentIcon(document: any): string {
    // Map actual shipment document types to available SVG icons
    const iconMap: { [key: string]: string } = {
      'ProofOfDelivery': 'document',
      'BillOfLading': 'bill-line', 
      'PapsLabel': 'shipments',
      'ParsLabel': 'shipments',
      'Fuel': 'truck', // Using truck icon for fuel
      'Toll': 'money-dollar-circle-line',
      'Repair': 'gear-icon',
      'Food': 'comments',
      'Stay': 'location',
      'Other': 'document',
      'ACIeManifest': 'document',
      'ACEeManifest': 'document',
      'RateConfirmation': 'bill-line'
    };
    
    // Try to match by document name, displayName, or type
    const documentType = document?.name || document?.displayName || document?.type || '';
    return iconMap[documentType] || 'files'; // Default to files icon
  }
}
